import axios from 'axios'

function getParameter(data) {
    var parameter = '?'
    for (var item in data) {
        parameter = parameter + item + '=' + data[item] + '&'
    }
    parameter = parameter.substring(0, parameter.length - 1)
    return parameter
}

//企业动态类型
export function getNewsTypeApi() {
    return axios({
        url: `api/tabDynamic/getNewsType`,
        method: 'get'
    })
}
//企业动态列表
export function getNewsListApi(data) {
    return axios({
        url: `api/tabDynamic/getNewsList${getParameter(data)}`,
        method: 'get'
    })
}
//企业动态详情
export function getNewsInfoApi(data) {
    return axios({
        url: `api/tabDynamic/getNewsInfo${getParameter(data)}`,
        method: 'get'
    })
}
//产品类型
export function getProductTypeApi() {
    return axios({
        url: `api/tabProduct/getProductType`,
        method: 'get'
    })
}
//产品列表
export function getProductListApi(data) {
    return axios({
        url: `api/tabProduct/getProductList${getParameter(data)}`,
        method: 'get'
    })
}
//产品详情
export function getProductInfoApi(data) {
    return axios({
        url: `api/tabProduct/getProductInfo${getParameter(data)}`,
        method: 'get'
    })
}

//解决方案类型
export function getPlanTypeApi() {
    return axios({
        url: `api/tabPlan/getPlanType`,
        method: 'get'
    })
}
//解决方案列表
export function getPlanListApi(data) {
    return axios({
        url: `api/tabPlan/getPlanList${getParameter(data)}`,
        method: 'get'
    })
}
//解决方案详情
export function getPlanInfoApi(data) {
    return axios({
        url: `api/tabPlan/getPlanInfo${getParameter(data)}`,
        method: 'get'
    })
}

//平台服务类型
export function getServiceTypeApi() {
    return axios({
        url: `api/tabService/getServiceType`,
        method: 'get'
    })
}
//平台服务详情
export function getServiceInfoApi(data) {
    return axios({
        url: `api/tabService/getServiceInfo${getParameter(data)}`,
        method: 'get'
    })
}



//下载中心
export function getFileDowloadApi(data) {
    return axios({
        url: `api/tabFileDowload/getFileDowload${getParameter(data)}`,
        method: 'get'
    })
}

//荣誉资质
export function getHonorInfoApi() {
    return axios({
        url: `api/tabHonor/getHonorInfo`,
        method: 'get'
    })
}

//底部
export function getUnderInfoListApi() {
    return axios({
        url: `api/homePage/getUnderInfoList`,
        method: 'get'
    })
}

//合作伙伴
export function getPartnerAllListApi(data) {
    return axios({
        url: `api/homePage/getPartnerAllList${getParameter(data)}`,
        method: 'get'
    })
}

//联系我们
export function getContactInfoApi(data) {
    return axios({
        url: `api/tabContact/getContactInfo`,
        method: 'get'
    })
}




//公司简介
export function getCompanyInfoApi() {
    return axios({
        url: `api/tabCompany/getCompanyInfo`,
        method: 'get',
    })
}
//
export function getCompanyInfoApi111(data) {
    return axios({
        url: `api/tabProduct/getProductInfo${getParameter(data)}`,
        method: 'get',
    })
}




// WEBPACK FOOTER //
// ./src/api/index.js